import { steps } from "@/data/content";

export const HowItWorks = () => {
  return (
    <section id="nain-toimii" className="py-16 sm:py-24 bg-[#245037] text-[#FDFBF7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-base font-bold text-[#E8C88A] uppercase tracking-wide">
            Näin se toimii
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-white">
            Avun saaminen on helppoa
          </h2>
          <p className="mt-4 text-lg sm:text-xl leading-relaxed text-[#E8E2D5]">
            Kolme yksinkertaista vaihetta – sinun ei tarvitse osata mitään etukäteen.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-8">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} data-testid={`step-${i}`} className="relative">
                <div className="w-16 h-16 rounded-2xl bg-[#E8C88A] flex items-center justify-center mb-5">
                  <Icon strokeWidth={2.5} className="w-8 h-8 text-[#245037]" />
                </div>
                <h3 className="text-2xl font-bold text-white">{s.title}</h3>
                <p className="mt-3 text-lg leading-relaxed text-[#E8E2D5]">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
